import { motion } from "framer-motion";

const STEPS = [
  {
    n: "01",
    title: "Answer 15 questions",
    body: "Across strategy, data, automation, team and commercial outcomes, calibrated for B2B revenue teams.",
  },
  {
    n: "02",
    title: "AI scores your maturity",
    body: "Peak One Partners analyses your responses against 5 dimensions and benchmarks the gap between you and revenue leaders.",
  },
  {
    n: "03",
    title: "Receive your scorecard",
    body: "A personalised, exec-ready report with strengths, gaps, and prioritised growth moves you can ship next quarter.",
  },
];

export default function HowItWorks() {
  return (
    <section id="how" data-testid="how-section" className="relative py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-6 md:px-12 lg:px-16">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div>
            <div className="text-xs font-mono uppercase tracking-[0.2em] text-[#00E5FF]">
              / Process
            </div>
            <h2 className="font-heading text-4xl md:text-5xl font-bold tracking-tighter mt-4 max-w-2xl">
              From quiz to commercial plan in under 5 minutes.
            </h2>
          </div>
          <p className="text-white/60 max-w-md text-base">
            No generic frameworks. The scorecard is generated against your specific
            answers and revenue context, every report is unique.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-white/10 border border-white/10">
          {STEPS.map((s, i) => (
            <motion.div
              key={s.n}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="bg-[#050505] p-8 md:p-10 group hover:bg-white/[0.03] transition-colors"
            >
              <div className="font-mono text-sm text-[#00E5FF]">{s.n}</div>
              <div className="font-heading text-2xl font-semibold mt-6">{s.title}</div>
              <p className="mt-4 text-white/60 leading-relaxed">{s.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
